import { render, staticRenderFns } from "./MyEducationDiscountLandingPage.vue?vue&type=template&id=ca5370b4"
import script from "./MyEducationDiscountLandingPage.vue?vue&type=script&lang=js"
export * from "./MyEducationDiscountLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports